/**
 * Created by Administrator on 2018/11/28 0028.
 */
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  uploadFileRequest,
  postRequestByJson
} from "./api";
import { setStore, getStore } from "./storage";

function myThen(data) {
  try {
    if (data.result || data.status) {
      return Promise.resolve(data.data);
    } else {
      Message.error(data.failMsg);
      return Promise.reject(data.failMsg);
    }
  } catch (e) {
    return Promise.reject(data);
  }
}
//首页
export const indexWeb = params => {
  return postRequest("/base/common/pc/indexWeb", params);
};
//首页推荐讲师
export const indexLecturers = params => {
  return postRequest("/base/common/pc/indexLecturers", params);
};
//获取Html
export const getHtmlWeb = params => {
  return getRequest("/base/common/pc/getHtmlWeb", params);
};
//服务协议页面
export const getHtml = params => {
  return postRequest("/base/common/getHtml", params);
};
//轮播图
export const slidersWeb = () => {
  return postRequest("/base/common/pc/slidersWeb");
};
export const slidersWebIndex = params => {
  return postRequest("/base/common/pc/slidersWebIndex", params);
};
//页面单张图
export const sliderPC = params => {
  return postRequest("/base/common/pc/sliderPC", params);
};
//讲师列表
export const lecturersList = params => {
  return postRequest("/base/common/pc/lecturersList", params);
};
//直播列表
export const liveListWeb = params => {
  return postRequest("/base/common/pc/liveListWeb", params);
};
//直播详情
export const liveDetailWeb = params => {
  return postRequest("/base/common/pc/liveDetailWeb", params);
};
//一级课程类别查课程列表
export const courseListFirstWeb = params => {
  return postRequest("/base/common/pc/courseListFirstWeb", params);
};
//全部课程列表
export const courseAllWeb = params => {
  return postRequest("/base/common/pc/courseAllWeb", params);
};
//推荐课程列表
export const recommendListWeb = params => {
  return postRequest("/base/common/pc/recommendListWeb", params);
};
//课程列表
export const courseListWeb = params => {
  return postRequest("/base/common/pc/courseListWeb", params);
};
//课程类型查询
export const coursetypeWeb = params => {
  return postRequest("/base/common/pc/coursetypeWeb", params);
};
//课程详情
export const courseDetail = params => {
  return postRequest("/base/common/pc/courseDetail", params);
};
//发表评论
export const reply = params => {
  return postRequest("/base/attention/reply", params);
};
//获取评论
export const getReplysWeb = params => {
  return postRequest("/base/common/pc/getReplysWeb", params);
};
//线下课程列表
export const offlineCourseListWeb = params => {
  return postRequest("/base/common/pc/offlineCourseListWeb", params);
};
//线下课程详情
export const offlineCourseDetailWeb = params => {
  return postRequest("/base/common/pc/offlineCourseDetailWeb", params);
};
//VIP页面（弃用）
export const vipPageWeb = () => {
  return postRequest("/base/common/pc/vipPageWeb");
};
//VIP配置
export const vipPage = () => {
  return postRequest("/base/common/vipPage");
};
//个人vip购买信息
export const mine = params => {
  return postRequest("/base/user/mine", params);
};
//课程类型列表
export const coursetypeList = () => {
  return postRequest("/base/common/coursetype_list");
};
//讲师系列课程
export const lecturerCourseWeb = params => {
  return postRequest("/base/common/pc/lecturerCourseWeb", params);
};
//
//点赞/收藏
export const collecon = params => {
  return postRequest("/base/attention/collecon", params);
};
//搜索课程
export const searchWeb = params => {
  return postRequest("/base/common/pc/searchWeb", params);
};
//分享（获取积分）
export const shareApp = params => {
  return postRequest("/base/attention/shareApp", params);
};

//个人中心
//个人信息（个人中心左侧）
export const centreInfoWeb = params => {
  return postRequest("/base/pcAbility/centreInfoWeb", params);
  // let Obj = { code: 200 };
  // return Promise.resolve(Obj);
};
//观看记录
export const recordListWeb = params => {
  return postRequest("/base/pcUser/recordListWeb", params);
};
//批量删除观看记录
export const delHistoryWeb = params => {
  return postRequest("/base/pcUser/delHistoryWeb", params);
};
//我的收藏
export const userColleconWeb = params => {
  return postRequest("/base/pcUser/userColleconWeb", params);
};
//批量删除收藏
export const delColleconWeb = params => {
  return postRequest("/base/pcAbility/delColleconWeb", params);
};
//我的计划
export const myPlanPageWeb = params => {
  return postRequest("/base/pcAbility/myPlanPageWeb", params);
};
//计划详情
export const myPlanDetail = params => {
  return postRequest("/base/pcAbility/myPlanDetail", params);
};
//更新学习计划
export const sendPlan = params => {
  return postRequest("/base/attention/sendPlan", params);
};
//我的积分
export const myIntegralRecordWeb = params => {
  return postRequest("/base/pcAbility/myIntegralRecordWeb", params);
};
//我的消息
export const messageListWeb = params => {
  return postRequest("/base/message/messageListWeb", params);
};
//消息详情
export const getMessage = params => {
  return postRequest("/base/message/getMessage", params);
};
//我的发票记录
export const myInvoicePageWeb = parmas => {
  return postRequest("/base/pcOrder/myInvoicePageWeb", parmas);
};
//用户待开票
export const invoiceWaitWeb = parmas => {
  return postRequest("/base/pcOrder/invoiceWaitWeb", parmas);
};
//我的订单
export const orderListWeb = params => {
  return postRequest("/base/pcOrder/orderListWeb", params);
};
//取消订单
export const cancelOrderWeb = params => {
  return postRequest("/base/pcOrder/cancelOrderWeb", params);
};
//删除订单
export const delOrder = params => {
  return postRequest("/base/order/delOrder", params);
};
//订单详情
export const orderDetail = params => {
  return postRequest("/base/order/orderDetail", params);
};
//申请发票
export const addInvoice = params => {
  return postRequest("/base/order/addInvoice", params);
};
//申请发票页面
export const applyInvoicePage = params => {
  return postRequest("/base/order/applyInvoicePage", params);
};
//我的能力分
export const userAbility = params => {
  return postRequest("/base/ability/userAbility", params);
};
//我的学历分
export const myEducationPage = params => {
  return postRequest("/base/ability/myEducationPage", params);
};
//我的工作分
export const myWorkPage = params => {
  return postRequest("/base/ability/myWorkPage", params);
};
//天梯图获取数据
export const lineData = params => {
  return getRequest("/base/common/line_data", params);
};
export const line_data2 = params => {
  return getRequest("/base/common/line_data2", params);
};
//能力雷达图主
export const radarPage = params => {
  return postRequest("/base/ability/radarPage", params);
};
//能力雷达图副
export const radarPage2 = params => {
  return postRequest("/base/ability/radarPage2", params);
};
//我的学习币充值
export const chargeconfigWeb = params => {
  return postRequest("/base/pcAbility/chargeconfigWeb", params);
};
//个人资料展示
export const userDataWeb = params => {
  return postRequest("/base/pcUser/userDataWeb", params);
};
//基本资料修改
export const updataUserData = params => {
  return postRequest("/base/user/update", params);
};
//教育经历
export const educationList = params => {
  return postRequest("/base/user/education_list", params);
};
//修改教育经历
export const updateEducation = params => {
  return postRequest("/base/user/updateEducation", params);
};
//工作经历
export const workCourseList = params => {
  return postRequest("/base/user/workcourse_list", params);
};
//新增工作经历页面
export const workCourseAdd = params => {
  return postRequest("/base/user/workcourse_add", params);
};
//新增工作经历
export const workCourseSubmit = params => {
  return postRequest("/base/user/workcourse_sub", params);
};

//人才测评
//人才测评页面
export const abilityPage = params => {
  return postRequest("/base/ability/abilityPage", params);
};
//用户基本资料
export const userData = params => {
  return postRequest("/base/user/info", params);
};
//提交基本资料
export const updateUserData = params => {
  return postRequest("/base/user/update", params);
};
//获取题目
export const getSubject = params => {
  return postRequest("/base/ability/getSubject", params);
};
//提交答案
export const subExam = params => {
  return postRequest("/base/ability/subExam", params);
};

//登录
//手机号加密
export const getMobile = params => {
  return postRequest("/base/common/pc/getMobile", params);
};
//获取验证码注册
export const sendSms = params => {
  return getRequest("/base/common/sendSms", params);
};
//获取验证码（不注册）
export const sendSms2 = params => {
  return postRequest("/base/common/sendSms2", params);
};
//校验验证码
export const verify_smscode_app = params => {
  return postRequest("/base/common/yanzheng", params);
};
//换绑手机
export const changePhone = params => {
  return postRequest("/base/attention/changePhone", params);
};
//登录
export const loginApp = params => {
  return postRequest("/login/token", params);
};
//登录初始化
export const initLogin = () => {
  return postRequest("/base/common/init_login");
};
//token刷新
export const refreshtoken = params => {
  return postRequest("/auth/oauth/token", params);
};

//支付
//创建订单
export const addOrder = params => {
  return postRequest("/base/order/addOrder", params);
};
// //支付页面
// export const buyPageWeb = (params) => {
//   return postRequest('/base/pcOrder/buyPageWeb',params)
// }
//订单转支付页面
export const orderbuyPageWeb = params => {
  return postRequest("/base/pcOrder/orderbuyPageWeb", params);
};
//订单支付成功页面
export const orderSuccess = params => {
  return postRequest("/base/common/pc/orderSuccess", params);
};

//支付二维码生成（支付宝微信）
export const toQrPay = params => {
  return postRequest("/base/common/toQrPay", params);
};
//支付订单状态查询（支付过程中）
export const payorderStatusWeb = params => {
  return postRequest("/base/pcOrder/payorderStatusWeb", params);
};
//学习币支付
export const balancePayWeb = params => {
  return postRequest("/base/pcOrder/balancePayWeb", params);
};
//模糊查询税号
export const selectCompany = params => {
  return postRequest("/base/order/selectCompany", params);
};
//根据企业code查询税号
export const findByCompany = params => {
  return postRequest("/base/order/findByCompany", params);
};

//第三方登录
//第三方绑定手机号
export const bindMobile = params => {
  return postRequest("/base/common/bind_mobile", params);
};
//获取第三方登录地址
export const thirdLoginAddress = () => {
  return getRequest("/auth/login/other/config");
};

//银联支付
export const unionPay = params => {
  return postRequest("/base/pay/unionpay", params);
};

//播放异常
export const findVideo = params => {
  return postRequest("/base/common/findByVideo", params);
};

//学分转换
//学分转换页面
export const scorePage = params => {
  return postRequest("/base/attention/scorePage", params);
};
//学分转换查询
export const checkScore = params => {
  return postRequest("/base/attention/checkScore", params);
};
//提交学分转换基本信息
export const updateCreditbank = params => {
  return postRequest("/base/attention/updateCreditbank", params);
};
//提交学分转换证书信息
export const subCertif = params => {
  return postRequest("/base/attention/subCertif", params);
};

//新闻列表
export const newsList = params => {
  return postRequest("/base/common/pc/newsList", params);
};
//新闻详情
export const newsDetail = params => {
  return postRequest("/base/common/pc/newsDetail", params);
};
//帮助中心列表
export const issuePageWeb = params => {
  return postRequest("/base/common/pc/issuePageWeb", params);
};
//帮助中心详情
export const issuePageDetail = params => {
  return postRequest("/base/common/pc/issuePageDetail", params);
};

//考试分类
export const examType = params => {
  return postRequest("/base/user/examType", params);
};
//获取个人信息
export const userInfo = params => {
  return postRequest("/base/user/userInfo", params);
};
//考试列表
export const getExamlist = params => {
  return postRequest("/base/user/examTypelist", params);
};
//获取字典项
export const getDicList = params => {
  return postRequest("/base/third/getdicData", params);
};
//更新用户信息
export const updateUserInfo = params => {
  return postRequest("/base/user/updateUserInfo", params);
};
//教育经历初始
export const getUserEducation = params => {
  return postRequest("/base/third/educationlist", params);
};
//添加教育经历
export const addEducation = params => {
  return postRequest("/base/third/addEducation", params);
};
//校验考试报名
export const yzexamItem = params => {
  return postRequest("/base/user/yzexamItem", params);
};
//删除教育经历
export const delEducation = params => {
  return postRequest("/base/user/delEduation", params);
};
//工作经历初始
export const getUserWork = params => {
  return postRequest("/base/third/work_list", params);
};
//添加教育经历
export const addWork = params => {
  return postRequest("/base/third/addwork", params);
};
//删除工作经历
export const delWork = params => {
  return postRequest("/base/user/delwork", params);
};
//培训经历初始
export const getPeixun = params => {
  return postRequest("/base/third/train_list", params);
};
//添加培训经历
export const addPeixun = params => {
  return postRequest("/base/third/addtrain", params);
};
//删除培训经历
export const delPeixun = params => {
  return postRequest("/base/user/delTrain", params);
};
//培训机构列表
export const getTran = params => {
  return postRequest("/base/third/getdicData", params);
};
//用户证书初始
export const getUserCertificate = params => {
  return postRequest("/base/user/userzsList", params);
};
//添加用户证书初始
export const addUserCertificate = params => {
  return postRequest("/base/user/addusercertificate", params);
};
//删除用户证书
export const delUserCertificate = params => {
  return postRequest("/base/user/delcertificate", params);
};
//考试场次列表
export const getApplyExamList = params => {
  return postRequest("/base/user/getexamSeason", params);
};
//报考考试
export const addsubjects = params => {
  return postRequest("/base/user/addsubjects", params);
};
//我的考试
export const getmyExamination = params => {
  return postRequest("/base/user/myExamination", params);
};
//根据目标id查询订单
export const getOrderByTarget = params => {
  return postRequest("/base/pcOrder/getOrderByTarget", params);
};

/** 我的证书 **/
//查询证书列表
export const getCertificateTree = params => {
  return postRequest("/base/certificate/selectList", params);
};
//查询用户证书列表
export const meCertificate = params => {
  return postRequest("/base/optionCertificate/meCertificate", params);
};
//查询证书兑换对应的学科学分
export const getcertifiConfig = params => {
  return postRequest("/base/optionCertificate/getcertifiConfig", params);
};
//申请转换证明
export const addcertChange = params => {
  return postRequest("/base/optionCertificate/addcertChange", params);
};
//证书认定考试类型
export const getexamType = params => {
  return postRequest("/base/user/getexamType", params);
};
//证书认定考试报名
export const addexam = params => {
  return postRequest("/base/user/addexam", params);
};
//继续教育页面
export const keepStudy = params => {
  return postRequest("/base/optionCertificate/keepStudy", params);
};
//继续教育活动学时
export const activeyList = params => {
  return postRequest("/base/optionCertificate/activeyList", params);
};
//添加活动学时
export const addActivity = params => {
  return postRequest("/base/optionCertificate/addActivity", params);
};
//学习证明列表
export const prooRemark = params => {
  return postRequest("/base/optionCertificate/prooRemark", params);
};
//添加继续教育课程学习记录
export const addstudyDetail = params => {
  return postRequest("/base/common/addstudyDetail", params);
};
//下载证书
export const downCertifite = params => {
  return postRequest("/base/common/downCertifite", params);
};
//学分银行证书列表
export const bankList = params => {
  return postRequest("/base/optionCertificate/bankList", params);
};
//转换记录列表
export const getchangeList = params => {
  return postRequest("/base/optionCertificate/getchangeList", params);
};
//转换记录列表
export const searchByNum = params => {
  return postRequest("/base/pcAbility/searchByIdCard", params);
};
//添加活动学时
export const saveidentity = params => {
  return postRequest("/base/user/saveidentity", params);
};
//添加活动学时
export const identiybody = params => {
  return postRequest("/base/user/identiybody", params);
};
export const getExamData = (params = {}) => {
  return postRequestByJson("/api/exam/third/query/examInfo", params);
};
export const submitAnswer = (params = {}) => {
  return postRequestByJson("api/exam/third/submit", params).then(myThen);
};



// WEBPACK FOOTER //
// ./src/http.js